module.exports = __webpack_public_path__ + "img/user-login.38d7e4e0.svg";